import { Action as BrandsAction } from '../actions/brands';
import { Action as StationInfoAction } from '../actions/station-info';
import { mergeReducer } from '../../lib/utils';

const defaultState = {
  isFetchingFeatBrands: false,
  isFetchingAllBrands: false,
  stationsByBrandId: {},
  brandsById: {},
  featuredBrands: [],
  error: undefined,
};

export default function brandsReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case BrandsAction.Brands.FeatBrandsCompleted:
      return {
        ...state,
        isFetchingFeatBrands: false,
        brandsById: body.brands.reduce(mergeReducer('brand_id'), { ...state.brandsById }),
        featuredBrands: body.brands.map(b => b.brand_id),
      };

    case BrandsAction.Brands.FeatBrandsFailed:
      return {
        ...state,
        isFetchingFeatBrands: false,
        error: body,
      };

    case BrandsAction.Brands.BrandsCompleted:
      return {
        ...state,
        isFetchingAllBrands: false,
        brandsById: {
          ...state.brandsById,
          ...body.brands.reduce(mergeReducer('brand_id'), {}),
        },
        allBrandsLoaded: body.allBrandsLoaded,
      };

    case BrandsAction.Brands.BrandsFailed:
      return {
        ...state,
        isFetchingAllBrands: false,
        error: body,
      };

    case StationInfoAction.StationInfo.BrandStationsCompleted:
      return {
        ...state,
        stationsByBrandId: {
          ...state.stationsByBrandId,
          [body.brandId]: body.stations?.map(station => station.id) || [],
        },
      };

    case BrandsAction.Brands.BrandsPending:
      return {
        ...state,
        error: undefined,
        isFetchingAllBrands: true,
      };

    case BrandsAction.Brands.FeatBrandsPending:
      return {
        ...state,
        isFetchingFeatBrands: true,
      };

    default:
      return state;
  }
}
